'use client'

// imports
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:dotorg-next":true});}catch(e){}}();import Cookies from 'js-cookie';
import { useAtomValue } from 'jotai';
import { useEffect, useRef } from 'react';

// lib files
import { getFavoriteStations, setFavoriteStation } from '@/lib/profile';
import { setStationCookie } from '@/lib/helpers/set-station-cookie';
import { useIdentity } from '@/lib/hooks/useIdentity';
import validateStationId from '@/lib/helpers/validate-station';
import { clientMetricLogger } from '@/lib/logger-client';
import { confirmedStationIdAtom } from '@/lib/atoms/confirmed-station-id';

// constants
import { STATION_ID_COOKIE } from '@/lib/constants';

// metrics
import { CLIENT_PROFILE_METRICS } from '@/lib/metric-strings';

/**
 * Relocalizes a signed-in user on pbs.org to their favorite station.
 *
 * Separate from the profile fetch so a failure to relocalize cannot affect
 * whether the user is considered signed in. pbs.org only: on an SVP the localized
 * station is the site itself.
 */
const NetworkFavoriteStation = () => {
  const { identity } = useIdentity()
  const confirmedStationId = useAtomValue(confirmedStationIdAtom)
  const checkedFor = useRef<string | null>(null)

  useEffect(() => {
    if (!identity) return
    // Once per uid per mount, so a favorite changed elsewhere is picked up on the
    // next navigation rather than by a background poll forcing a reload.
    if (checkedFor.current === identity.uid) return

    checkedFor.current = identity.uid

    const relocalize = async () => {
      const favoriteStations = await getFavoriteStations(identity.uid)
      const favoriteStation = favoriteStations?.collections?.[0]?.content[0]
      const currentStationID = Cookies.get(STATION_ID_COOKIE)

      if (!favoriteStation || !currentStationID) return
      if (window.pbsPlatform !== 'pbsorg') return
      if (currentStationID === favoriteStation.cid) return
      if (currentStationID === confirmedStationId) return

      if (await validateStationId(favoriteStation.cid)) {
        await clientMetricLogger(
          CLIENT_PROFILE_METRICS.NAMESPACE,
          `${CLIENT_PROFILE_METRICS.POLL_FORCED_RELOAD} - pid: ${identity.uid}, currentStation: ${currentStationID}, favoriteStation: ${favoriteStation.cid}, isRefresh: false`,
        )
        setStationCookie(favoriteStation)
        window.location.reload()
        return
      }

      // Favorite is no longer a valid station, so adopt where they are.
      await setFavoriteStation(currentStationID, identity.uid)
    }

    relocalize().catch((error) => console.error('Unable to relocalize to favorite station', error))
  }, [identity, confirmedStationId])

  return null;
}

export default NetworkFavoriteStation
